import React from "react";
import moment from "moment";

import { USER_ROLE } from "../modules/components/utils/contantHelpers";
import { CustomLoader } from "../modules/components";

import {
  getCouvertureUrl,
  getStartupPath,
} from "../utils/startup.utils";

export function StartupList({
  startups,
  role,
}) {
  if (!startups) {
    return <CustomLoader />;
  }

  return (
    <div className="PageContent">
      <div
        id="Filter-Active_Inactif"
        className="row Filter-Active_Inactif"
      >
        {startups.map((startup) => {
          const startupPath = getStartupPath(
            startup?._id,
            role,
          );

          const couvertureUrl =
            getCouvertureUrl(startup);

          const statusClass = startup?.status
            ? "col-lg-3 col-md-4 col-12 mix Active"
            : "col-lg-3 col-md-4 col-12 mix Inactif";

          const indicatorClass = startup?.status
            ? "StartUPBOX-Active"
            : "StartUPBOX-Inactive";

          return (
            <div
              key={startup?._id}
              className={statusClass}
            >
              <div className="StartUPBOX">
                <div className="StartUPBOX-Thumb">
                  <div className={indicatorClass} />

                  <a href={startupPath}>
                    {couvertureUrl && (
                      <img
                        src={couvertureUrl}
                        alt={
                          startup?.nom
                            ? `Couverture ${startup.nom}`
                            : "Couverture entreprise"
                        }
                        loading="lazy"
                      />
                    )}
                  </a>
                </div>

                <div className="StartUPBOX-Details">
                  <span className="StartUPBOX-DetailsSector">
                    {startup?.secteur}
                  </span>

                  <h4 className="StartUPBOX-DetailsName">
                    <a
                      className="StartUPBOX-DetailsLink"
                      href={startupPath}
                    >
                      {startup?.nom}
                    </a>
                  </h4>

                  {role === USER_ROLE.STARTUP ? (
                    <>
                      <span className="StartUPBOX-DetailsBudget">
                        {startup?.ca}
                      </span>

                      <span className="StartUPBOX-DetailsDate">
                        <i className="uil uil-calendar-alt" />

                        {" "}
                        {startup?.creation
                          ? moment(
                              new Date(startup.creation),
                            ).format("DD/MM/YYYY")
                          : ""}
                      </span>
                    </>
                  ) : (
                    <span className="StartUPBOX-DetailsBudget">
                      {startup?.activite}
                    </span>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
